export enum LanguageResource {
  ServiceProvider = 'ServiceProvider',
  ServiceProviderAndDeliveryNote = 'ServiceProviderAndDeliveryNote',
}
